import styled from '@emotion/styled'
import { White } from '@mehilainen/mds-customer/colors'
import { Button } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthorizedPerson, User } from '../../../__generated__/api'
import { ColumnFlex } from '../../../common/components/Layout/Layout'
import ModalHeader from '../../../common/components/Modal/ModalHeader/ModalHeader'
import ResponsiveModal from '../../../common/components/Modal/ResponsiveModal/ResponsiveModal'
import { getEmptyUser } from '../../../domain/reserve/components/utils'
import useReserveState from '../../../domain/reserve/hooks/useReserveState'

import UserSelect from './UserSelect'

const Container = styled(ColumnFlex)``

const ModalContentContainer = styled(ColumnFlex)`
  background: ${White};
  height: 100%;
`

interface Props {
  users?: AuthorizedPerson[]
  loggedInUser: User | undefined
  onSelectUser(user: User): void
}

const UserSelectModalButton: React.FC<React.PropsWithChildren<Props>> = ({
  users,
  loggedInUser,
  onSelectUser,
}) => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const { selectedInsuranceContractId } = useReserveState()
  return (
    <Container>
      <Button type="button" variant="outlined" onClick={() => setIsModalOpen(true)}>
        {t('component.reserveUserSelect.changeButtonText')}
      </Button>

      <ResponsiveModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <ModalContentContainer>
          <ModalHeader open={isModalOpen} onClose={() => setIsModalOpen(false)} />
          <UserSelect
            users={users}
            onSelectUser={(user) => {
              onSelectUser(user)
              setIsModalOpen(false)
            }}
            onReserveSelf={() => {
              onSelectUser(loggedInUser ?? getEmptyUser())
              setIsModalOpen(false)
            }}
            appointmentInfo={null}
            node={null}
            nodePending={false}
            disableUndefinedSelection={Boolean(selectedInsuranceContractId)}
          />
        </ModalContentContainer>
      </ResponsiveModal>
    </Container>
  )
}

export default UserSelectModalButton
